import angular from 'angular';
import 'angular-recursion';
import {
  loaderService,
  ssDialogService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
} from 'app/components/global';
import previewTopSectionDialog from './dialog.previewTopSectionDialog';
import editSectionDialog from './dialog.editSectionDialog';
import syncSectionCompareDialog from './dialog.syncSectionCompareDialog';
import controller from './section.controller';
import directive from './section.directive';

/* RecursionHelper doesn't export its name, so we provide that here */
const RecursionHelper = 'RecursionHelper';


export default angular.module('app.components.advisory.pm.section', [
  editSectionDialog,
  loaderService,
  previewTopSectionDialog,
  syncSectionCompareDialog,
  RecursionHelper,
  ssDialogService,
  confirmDialog,
  alerts,
])
  .directive('pmSection', directive)
  .controller('SectionController', controller)
  .name;

console.log('app.components.advisory.pm.section created');
